import React, { useContext, useEffect, useRef, useState } from "react"
import { AiPhotoButton } from "./AiListImport"   // tog'a #3355/#3408
import { Button, Drawer, Input, InputNumber, message as antMessage, Popconfirm, Switch } from "antd"
import StickyTable from "../table/StickyTable"   // tog'a #4695/#4703: hamma jadvalda sarlavha va «Итого» qotadi
import AiForecastLine from "./AiForecastLine"   // Boshliq (2026-09-05): sarf asosida tavsiya
import AiUsersAdmin from "./AiUsersAdmin"   // tog'a #3835
import { Bar } from "@ant-design/charts"
import { AudioOutlined, ClearOutlined, FullscreenExitOutlined, FullscreenOutlined, SendOutlined, SettingOutlined, SoundOutlined, StopOutlined } from "@ant-design/icons"
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import useVoiceRecorder from "../../hooks/useVoiceRecorder"   // tog'a #273: audio-react-recorder bo'sh yozuv berardi
import { AuthContext } from "../../contexts/auth/AuthContext"
import { isFactoryUser, isShopUser } from "../../utils/hasPermission"
import { request } from "../../utils/config"
import i18n from "../../services/i18n"
import "./aiChat.less"
import { nonNeg } from "../../utils/nonNeg"   // tog'a #1952: son 0 dan past ko'rsatilmaydi
import { Select } from "antd"
import { VOICE_MAX_SECONDS, blobToBase64, toSpeechWav } from "./aiVoice"   // tog'a #2506: 2 daqiqa, avval matn
import { useHistory } from "react-router-dom"
import { colLabel, fmtCell, isHiddenCol, titleColIndex, toolLabel } from "./aiTableLabels"
import { useSectionNames } from "../../utils/sectionNames"   // tog'a #3902: bo'lim nomi tizim ichida o'zgartirilgan bo'lsa (#3481)   // tog'a #3413

// tog'a #2688/#2694 (2026-09-24): «ovozli buyruq QAYERGA yozilishi chiqsin va tasdiqlansa tizimga kiritsin» — tog'a AI xarajatini
// «Деньги»da qidirdi (xarajat «Расходы»da edi) va topolmay qayta so'radi → ikki marta yozildi. Karta endi tasdiqdan OLDIN
// qaysi bo'limga yozilishini, KEYIN esa qaysi raqamlar bilan yozilganini va bo'limni ochish tugmasini ko'rsatadi.
// #2696: bo'lim nomi — menyudagi nom bilan bir xil kalit (foydalanuvchi menyuda nimani ko'rsa, shu yoziladi)
const AI_DEST: Record<string, { key: string; fb: string; link: string }> = {
  add_expenses: { key: "expenses", fb: "Расходы", link: "/expenses" },
  add_money: { key: "money", fb: "Деньги", link: "/moneys" },
  add_transfer: { key: "transfers", fb: "Переводы", link: "/transfers" },
}
const destName = (tool: string) => { const d = AI_DEST[tool]; return d ? i18n.t(d.key, d.fb) : "" }
const idList = (ids?: number[]) => (ids || []).map((x) => "#" + x).join(", ")
// Kartadagi tugma o'rniga yozilgan TASDIQ so'zi (server AiExpenseTool.IsConfirmWord bilan bir xil ro'yxat)
const CONFIRM_RE = /^(tasdiq\w*|ha|xa|haa|ok|okay|hop|xop|xo'p|ho'p|bajar\w*|confirm\w*|yes|да|подтвер\w*|ок)$/i
export const isConfirmWord = (s: string) => {
  const t = String(s || "").trim().replace(/[.!\s]+$/, "").toLowerCase().replace(/[’‘ʻʼ`]/g, "'")
  return t.length > 0 && t.length <= 24 && CONFIRM_RE.test(t)
}

// AI yordamchi — SAV AI. Suhbatlar serverda saqlanadi; admin boshqa
// userlar uchun AI'ni o'chirib/yoqib boshqaradi (pastdagi ⚙ bo'lim).

// B2: AI tayyorlagan, tasdiq kutayotgan amal
// tog'a #2506: tahrirlanadigan jadval (masalan xarajatlar) — server Prepare bilan qayta tekshiradi
interface AiPreviewCol { key: string; title: string; type: "date" | "text" | "number" | "select"; editable?: boolean; options?: { value: string; label: string }[] }
interface AiPreviewTable { editable?: boolean; columns: AiPreviewCol[]; rows: Record<string, any>[] }
interface AiPreview { title: string; lines: string[]; warning?: string | null; table?: AiPreviewTable | null }
interface AiPending {
  id: number
  tool: string
  preview: AiPreview
  expiresAt: string
}

interface AiMsg {
  role: "user" | "assistant"
  content: string
  tools?: { tool: string; args: string }[]
  // 8.1: tool natijasidan qurilgan jadval (backend beradi)
  table?: { title: string; columns: string[]; rows: any[][] }
  // B2: «shuni qilaymi?» kartochkasi — foydalanuvchi tasdiqlamaguncha bajarilmaydi
  pending?: AiPending | null
  /** "done" | "rejected" | "dup" (takror ogohlantirishi) | xato matni — kartochka hal qilingandan keyin */
  pendingResult?: string
  /** tog'a #2688: server javobi — «Bajarildi — «Расходы» bo'limiga yozildi: 2 ta (#21, #22)» yoki takror ogohlantirishi */
  pendingNote?: string
  pendingLink?: string
  /** #2696: yozilgan / takror yozuvlar raqamlari — matn interfeys tilida quriladi */
  pendingIds?: number[]
  /** tog'a #3904: yozuv amali so'raldi, bo'lim aniq emas — «Qaysi bo'limda?» tugmalari (bosilsa so'rov shu bo'limda qayta yuboriladi) */
  sectionOptions?: AiSection[]
}

/** tog'a #3902/#3907: AI bo'limi — foydalanuvchiga rol (va menejer kartasi) bo'yicha ochiqlari (AIAgent/Sections) */
type AiSection = { key: string; name: string; canWrite?: boolean }
const AI_SECTION_LS = "ai.section"

// B2: «Shuni qilaymi?» kartochkasi.
// AI hech qachon o'zi yozmaydi — bu kartochka tasdiqlanmaguncha bazada
// hech narsa o'zgarmaydi. Tasdiqlangandan keyin ham amal MAVJUD servis
// metodi orqali bajariladi (biznes mantiq, tenant filtri, audit — hammasi joyida).
function PendingActionCard({
  pending,
  result,
  busy,
  onDecide,
  note,
  link,
  onOpen,
  autoConfirm,
  ids,
}: {
  pending: { id: number; tool: string; preview: AiPreview }
  result?: string
  busy: boolean
  onDecide: (confirm: boolean, edited?: Record<string, any>[], force?: boolean) => void
  note?: string
  link?: string
  onOpen?: (link: string) => void
  /** tog'a #2688: foydalanuvchi «tasdiqla» deb yozdi — karta o'zini tasdiqlaydi (tahrirlangan qatorlar bilan) */
  autoConfirm?: number
  ids?: number[]
}) {
  const done = result === "done"
  const rejected = result === "rejected"
  const dup = result === "dup"
  const failed = !!result && !done && !rejected && !dup && result !== "invalid"
  const dest = AI_DEST[pending.tool]
  const tbl = pending.preview?.table
  // tog'a #2506: jadval kartada TAHRIRLANADI; «Tasdiqlash» tahrirlangan qatorlarni yuboradi (server qayta tekshiradi)
  const [rows, setRows] = useState<Record<string, any>[]>(() => (tbl?.rows || []).map((r) => ({ ...r })))
  const [edited, setEdited] = useState(false)
  const setCell = (ri: number, key: string, v: any) => {
    setEdited(true)
    setRows((prev) => prev.map((r, i) => (i === ri ? { ...r, [key]: v, ...(key === "document" ? { section: String(v || "").trim() ? "Zakupka xarajati" : "Umumiy xarajat" } : {}) } : r)))
  }
  const canEdit = !!tbl?.editable && !result
  useEffect(() => {
    if (autoConfirm && (!result || result === "invalid") && !busy) onDecide(true, tbl?.editable && edited ? rows : undefined)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [autoConfirm])
  // jami — JORIY (tahrirlangan) qatorlardan: dollar va so'm alohida (server ham shunday qo'shadi)
  const jami = (() => {
    if (!tbl) return null
    // ikki shakl: xarajat (currency + amount) va pul (amountUSD + amountUZS)
    const usd = rows.reduce((a, r) => a + (r.currency === "USD" ? Number(r.amount) || 0 : 0) + (Number(r.amountUSD) || 0), 0)
    const uzs = rows.reduce((a, r) => a + (r.currency === "UZS" ? Number(r.amount) || 0 : 0) + (Number(r.amountUZS) || 0), 0)
    const q: string[] = []
    if (usd > 0) q.push("$" + usd.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }))
    if (uzs > 0) q.push(Math.round(uzs).toLocaleString("ru-RU") + " so'm")
    return "Jami: " + (q.join(" + ") || "0")
  })()
  const cols = (tbl?.columns || []).map((c) => ({
    title: c.title, dataIndex: c.key, key: c.key,
    render: (v: any, _r: any, ri: number) => {
      if (!canEdit || !c.editable) {
        const opt = c.options?.find((o) => o.value === v)
        return <span>{opt ? opt.label : typeof v === "number" ? v.toLocaleString("ru-RU") : String(v ?? "")}</span>
      }
      if (c.type === "number") return <InputNumber size="small" min={0} value={v} style={{ width: 96 }} onChange={(x) => setCell(ri, c.key, x)} data-testid={`ai-cell-${c.key}-${ri}`} />
      if (c.type === "select") return <Select size="small" value={v} style={{ minWidth: 96 }} options={c.options || []} onChange={(x) => setCell(ri, c.key, x)} dropdownMatchSelectWidth={false} data-testid={`ai-cell-${c.key}-${ri}`} />
      if (c.type === "date") return <input type="date" className="ai-cell-date" value={v || ""} onChange={(e) => setCell(ri, c.key, e.target.value)} data-testid={`ai-cell-${c.key}-${ri}`} />
      return <Input size="small" value={v} style={{ minWidth: 90 }} onChange={(e) => setCell(ri, c.key, e.target.value)} data-testid={`ai-cell-${c.key}-${ri}`} />
    },
  }))
  return (
    <div className="ai-pending-card" data-testid="ai-pending-card">
      <div className="ai-pending-title">
        {done ? "✅ " : rejected ? "✖ " : failed ? "⚠ " : "❓ "}
        {pending.preview?.title || i18n.t("aiConfirmAction")}
      </div>
      {dest && !done && (
        <div className="ai-pending-dest" data-testid="ai-pending-dest">
          📍 {i18n.t("aiDestLine", { section: destName(pending.tool), defaultValue: "Куда запишется: раздел «{{section}}»" })}
        </div>
      )}
      <div className="ai-pending-lines">
        {(pending.preview?.lines || []).filter((l) => !(tbl && /^Jami:/.test(l))).map((l, i) => (
          <div key={i}>{l}</div>
        ))}
        {jami && <div data-testid="ai-pending-total">{jami}</div>}
      </div>
      {tbl && (
        <div className="ai-pending-table" data-testid="ai-pending-table">
          <StickyTable size="small" columns={cols as any} dataSource={rows.map((r, i) => ({ ...r, __k: i }))} rowKey="__k" pagination={false} scroll={{ x: "max-content" }} />
          {canEdit && <div className="ai-pending-hint">✏️ {i18n.t("aiTableEditHint", "Kataklarni tuzatish mumkin — «Tasdiqlash» tuzatilgan qiymatlar bilan yozadi")}</div>}
        </div>
      )}
      {pending.preview?.warning && <div className="ai-pending-warn">⚠ {pending.preview.warning}</div>}

      {(!result || result === "invalid") && (
        <div className="ai-pending-actions">
          <Button type="primary" size="small" loading={busy} onClick={() => onDecide(true, tbl?.editable && edited ? rows : undefined)} data-testid="ai-pending-confirm">
            Tasdiqlash
          </Button>
          <Button size="small" disabled={busy} onClick={() => onDecide(false)}>
            Bekor
          </Button>
        </div>
      )}
      {dup && (
        <div className="ai-pending-dup" data-testid="ai-pending-dup">
          <div className="ai-pending-warn">⚠ {dest && ids?.length
            ? i18n.t("aiDupLine", { section: destName(pending.tool), ids: idList(ids), defaultValue: "Такая же запись недавно уже внесена ({{ids}}) — раздел «{{section}}». Если внести ещё раз, она запишется дважды." })
            : note || i18n.t("aiDupWarn", "Такая же запись недавно уже внесена")}</div>
          <div className="ai-pending-actions">
            <Button danger size="small" loading={busy} onClick={() => onDecide(true, tbl?.editable && edited ? rows : undefined, true)} data-testid="ai-pending-force">
              {i18n.t("aiDupForce", "Baribir kiritish")}
            </Button>
            <Button size="small" disabled={busy} onClick={() => onDecide(false)}>
              {i18n.t("aiDupCancel", "Kiritmaslik")}
            </Button>
            {link && <Button type="link" size="small" onClick={() => onOpen?.(link)}>{i18n.t("aiOpenSection", "Bo'limni ochish")} →</Button>}
          </div>
        </div>
      )}
      {done && (
        <div className="ai-pending-done" data-testid="ai-pending-done">
          {dest && ids?.length
            ? i18n.t("aiWrittenLine", { section: destName(pending.tool), n: ids.length, ids: idList(ids), defaultValue: "✅ Записано в раздел «{{section}}»: {{n}} шт. ({{ids}})" })
            : note || i18n.t("aiDone")}
          {(link || dest?.link) && (
            <Button type="link" size="small" onClick={() => onOpen?.((link || dest?.link) as string)} data-testid="ai-pending-open">
              {i18n.t("aiOpenSection", "Bo'limni ochish")} →
            </Button>
          )}
        </div>
      )}
      {rejected && <div className="ai-pending-rejected">{i18n.t("aiRejected")}</div>}
      {failed && <div className="ai-pending-warn">{result}</div>}
    </div>
  )
}

// 8.1: AI tool natijasini jadval (+ raqamli ustun bo'lsa gorizontal bar-grafik)
// ko'rinishida chizadi. Xom SQL yo'q — faqat ruxsat-tekshirilgan tool ma'lumoti.
// tog'a #3413 (2026-10-04): ustunlar o'qiladigan nom bilan (xom «counterpartyName» emas), texnik id ustunlari yashirin,
// qiymatlar formatlangan ($, sana, so'm, %). Telefonda (tor oyna) jadval o'rniga ixcham kartalar — siqilgan ustunlar bo'lmaydi.
function AiResultTable({ table }: { table: { title: string; columns: string[]; rows: any[][] } }) {
  const [narrow, setNarrow] = useState(() => typeof window !== "undefined" && window.innerWidth < 600)
  useEffect(() => { const on = () => setNarrow(window.innerWidth < 600); window.addEventListener("resize", on); return () => window.removeEventListener("resize", on) }, [])
  const vis = table.columns.map((c, i) => ({ c, i })).filter((x) => !isHiddenCol(x.c))
  const ti = titleColIndex(table.columns)
  const cols = vis.map(({ c, i }) => ({
    title: colLabel(c), dataIndex: String(i), key: String(i),
    align: (typeof table.rows[0]?.[i] === "number" ? "right" : "left") as any,
    render: (v: any) => <span style={{ whiteSpace: "nowrap" }}>{fmtCell(c, v)}</span>,
  }))
  const data = table.rows.map((r, ri) => {
    const o: any = { key: ri }
    r.forEach((v, ci) => (o[String(ci)] = v))
    return o
  })
  // Grafik: birinchi matnli ustun (nom) vs birinchi raqamli ustun (qiymat) — texnik ustunlarsiz
  const nameIdx = ti >= 0 ? ti : vis.find((x) => typeof table.rows[0]?.[x.i] !== "number")?.i ?? -1
  const numIdx = vis.find((x) => typeof table.rows[0]?.[x.i] === "number")?.i ?? -1
  const showChart = table.rows.length >= 2 && nameIdx >= 0 && numIdx >= 0
  const chartData = showChart
    ? table.rows.map((r) => ({ name: String(r[nameIdx]), value: Number(r[numIdx]) || 0 }))
    : []
  return (
    <div className="ai-result">
      {table.title && <div className="ai-result-title">📋 {toolLabel(table.title)} · {table.rows.length}</div>}
      {narrow ? (
        <div className="ai-result-cards">
          {table.rows.slice(0, 30).map((r, ri) => (
            <div key={ri} className="ai-result-card">
              {ti >= 0 && <div className="ai-result-card-title">{fmtCell(table.columns[ti], r[ti])}</div>}
              <div className="ai-result-card-grid">
                {vis.filter((x) => x.i !== ti).map(({ c, i }) => (
                  <div key={i} className="ai-result-field"><span className="ai-result-label">{colLabel(c)}</span><span className="ai-result-value">{fmtCell(c, r[i])}</span></div>
                ))}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <StickyTable size="small" columns={cols as any} dataSource={data} className="ai-result-table"
          pagination={data.length > 8 ? { pageSize: 8, size: "small" } : false}
          scroll={{ x: true }} />
      )}
      {showChart && (
        <div style={{ marginTop: 8 }}>
          <Bar {...({
            data: chartData, xField: "value", yField: "name", height: Math.min(220, 40 + chartData.length * 26),
            animation: false, color: "#d8b645",   // SAV oltini
            label: { position: "right", formatter: (d: any) => Number(d.value).toLocaleString("ru-RU"), style: { fontSize: 10 } },
            xAxis: { label: { formatter: (v: string) => Number(v).toLocaleString("ru-RU") } },
          } as any)} />
        </div>
      )}
    </div>
  )
}

// tog'a #3413: tavsiya savollari interfeys tilida (avval o'zbekcha qattiq yozilgan edi)
const SUGGESTIONS = [i18n.t("aiSug1"), i18n.t("aiSug2"), i18n.t("aiSug3"), i18n.t("aiSug4")]

// **qalin** belgilarni chiroyli renderlash (AI javoblari markdown'da keladi)
function renderRich(text: string) {
  // tog'a #3413: markdown ro'yxat belgilari («- », «* ») → «•», «### sarlavha» → qalin, 3+ bo'sh qator → bitta bo'sh qator
  const clean = String(text || "")
    .replace(/\r/g, "")
    .replace(/^(\s*)[-*] (?=\S)/gm, "$1• ")
    .replace(/^#{1,4}\s*(.+)$/gm, "**$1**")
    .replace(/\n{3,}/g, "\n\n")
    .trim()
  const parts = clean.split(/\*\*(.+?)\*\*/g)
  return parts.map((p, i) =>
    i % 2 === 1 ? <b key={i}>{p}</b> : <React.Fragment key={i}>{p}</React.Fragment>
  )
}

export default function AIChatDrawer() {
  const { authState } = useContext(AuthContext)
  const user: any = authState.user
  const [open, setOpen] = useState(false)
  // tog'a #3488 (2026-10-04): AI oynasi butun ekranga — tanlov eslab qolinadi
  const [full, setFull] = useState<boolean>(() => { try { return localStorage.getItem("ai_full") === "1" } catch { return false } })
  const toggleFull = () => setFull((v) => { try { localStorage.setItem("ai_full", v ? "0" : "1") } catch {} return !v })
  const [manageOpen, setManageOpen] = useState(false)
  const [messages, setMessages] = useState<AiMsg[]>([])
  // tog'a #3902/#3904: tanlangan bo'lim (null — «Umumiy»). auto — AI gapdan aniqlagan (keyingi gapda boshqa bo'lim aniq aytilsa almashadi);
  // qo'lda tanlangani eslab qolinadi va almashmaydi.
  const [bolim, setBolim] = useState<{ key: string | null; auto: boolean }>(() => {
    try { return { key: localStorage.getItem(AI_SECTION_LS) || null, auto: false } } catch { return { key: null, auto: false } }
  })
  const tanlaBolim = (key: string | null) => {
    setBolim({ key, auto: false })
    try { if (key) localStorage.setItem(AI_SECTION_LS, key); else localStorage.removeItem(AI_SECTION_LS) } catch {}
  }
  const sectionsQ = useQuery(["AI_SECTIONS"], async () => (await request({ url: "AIAgent/Sections" })).data?.sections as AiSection[] || [],
    { enabled: open, staleTime: 5 * 60 * 1000, retry: false })
  const bolimlar: AiSection[] = Array.isArray(sectionsQ.data) ? sectionsQ.data : []
  const secNames = useSectionNames(open)
  // nom: tizim ichida o'zgartirilgani (#3481) → interfeys tilidagi tarjima → server nomi
  const nomi = (b: AiSection) => secNames[b.key.toLowerCase()]
    || (b.key === "orders" && b.name === "Заказ клиента" ? i18n.t("aiImgOrderClient", "Заказ клиента") : i18n.t("aiSec_" + b.key, b.name))   // hamkorda o'z zakazi
  // eslab qolingan bo'lim endi ochiq bo'lmasa (rol o'zgargan) — «Umumiy»
  useEffect(() => {
    if (sectionsQ.isSuccess && bolim.key && !bolimlar.some((b) => b.key === bolim.key)) tanlaBolim(null)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sectionsQ.isSuccess, sectionsQ.data])
  const bolimDan = (sec?: { key: string | null; auto: boolean }) => {
    const s = sec || bolim
    return { section: s.key || "all", sectionAuto: !!(s.key && s.auto) }
  }
  // server javobidagi bo'lim (eski server bu maydonni bermaydi — tegilmaydi)
  const bolimJavobdan = (d: any) => {
    if (!d || !("section" in d)) return
    if (d.sectionDenied) { tanlaBolim(null); return }
    if (d.section && d.section !== bolim.key) setBolim({ key: d.section, auto: !!d.sectionAuto })
  }
  // B2: hozir tasdiqlanayotgan amal id'si (ikki marta bosishning oldini oladi)
  const [pendingBusy, setPendingBusy] = useState<number | null>(null)
  const [autoConfirm, setAutoConfirm] = useState<{ id: number; n: number } | null>(null)   // tog'a #2688
  const history = useHistory()
  const [historyLoaded, setHistoryLoaded] = useState(false)
  const [input, setInput] = useState("")
  const [loading, setLoading] = useState(false)
  // tog'a #273: ovozli savol — MediaRecorder (tayyor yozuv transcribeVoice ga; u pastda e'lon qilingani uchun ref orqali)
  const aiVoiceDone = useRef<(b: Blob) => void>(() => {})
  const voice = useVoiceRecorder((b) => aiVoiceDone.current(b), (k) =>
    antMessage.warning(k === "denied" ? i18n.t("micDenied") : k === "unsupported" ? i18n.t("micUnsupported") : i18n.t("voiceEmpty")))
  const listRef = useRef<HTMLDivElement>(null)
  const queryClient = useQueryClient()

  const isSuperAdmin =
    user?.role === 1 || user?.roleId === 1 || user?.roleName === "super-admin"

  // Kabinet foydalanuvchilariga va admin o'chirgan userlarga AI ochilmaydi
  const isCounterparty =
    user?.userName === "Counterparty" ||
    user?.roleName === "counterparty" ||
    (user?.counterpartyId != null && user?.counterpartyId > 0 && user?.managerId == null)
  const aiDisabled = user?.aiEnabled === false || user?.aiEnabled === 0

  // Saqlangan suhbat tarixi (drawer birinchi ochilganda)
  useQuery(
    ["AI_CHAT_HISTORY"],
    async () => {
      const r = await request({ url: "AIAgent/History", params: { take: 60 } })
      return r.data
    },
    {
      enabled: open && !historyLoaded,
      onSuccess: (rows: any[]) => {
        setHistoryLoaded(true)
        if (Array.isArray(rows) && rows.length > 0) {
          setMessages(
            rows.map((r) => ({
              role: r.role === "assistant" ? "assistant" : "user",
              content: r.content || "",
              tools: r.toolsJson ? safeParse(r.toolsJson) : undefined,
            }))
          )
          scrollDown()
        }
      },
    }
  )

  // Admin: xodimlar ro'yxati, limit va AI yoqish — AiUsersAdmin ichida (tog'a #3835: barcha tizimlar, filtr, hammaga birdan)
  const isMainTenantAdmin = isSuperAdmin && Number(user?.tenantId || 1) <= 1

  // AI billing (ichki kredit+kvota): zaxira holati
  const { data: billing } = useQuery(
    ["AI_BILLING"],
    async () => (await request({ url: "AIAgent/Billing" })).data,
    { enabled: manageOpen && isSuperAdmin }
  )
  const { mutate: addCredit } = useMutation(
    async (p: { tenantId: number; addTokens: number }) =>
      request({ url: "AIAgent/Billing/AddCredit", method: "post", data: p }),
    {
      onSuccess: () => { antMessage.success(i18n.t("aiCreditAdded")); queryClient.invalidateQueries(["AI_BILLING"]) },
      onError: (e: any) => antMessage.error(e?.response?.data?.message || i18n.t("error")),
    }
  )

  const { mutate: clearHistory } = useMutation(
    async () => request({ url: "AIAgent/ClearHistory", method: "post" }),
    {
      onSuccess: () => {
        setMessages([])
        antMessage.success(i18n.t("aiChatCleared"))
      },
    }
  )

  // Boshliq (2026-09-03, S4): magazin/kontragent TIZIMI foydalanuvchisi (o'z tizimida, kabinet emas) — AI ochiq;
  // admin tizim uchun o'chirgan bo'lsa (tenantAiEnabled=false) — tugma yo'q
  const isTenantUser =
    Number(user?.tenantId || 0) > 1 &&
    (user?.tenantType === "shop_owner" || user?.tenantType === "counterparty") &&
    !(Number(user?.counterpartyId || 0) > 0)
  const tenantAiOff = user?.tenantAiEnabled === false
  // tog'a #2506: ovoz → matn holati va 2 daqiqalik yozuv taymeri — hook'lar erta `return` dan OLDIN (qoida: har renderda bir tartib)
  const [transcribing, setTranscribing] = useState(false)
  const [recSec, setRecSec] = useState(0)
  const recOn = voice.state === "recording"
  useEffect(() => {
    if (!recOn) { setRecSec(0); return }
    const t0 = Date.now()
    const iv = setInterval(() => {
      const s2 = Math.floor((Date.now() - t0) / 1000)
      setRecSec(s2)
      if (s2 >= VOICE_MAX_SECONDS) voice.stop()
    }, 500)
    return () => clearInterval(iv)
  }, [recOn])
  // Tog'a (2026-10-30, skrinshot #464): «Голосовой ответ» — javob ovozda o'qiladi (brauzer nutq sintezi, server kerak emas);
  // «Диалог» — gapirasiz → matnga → yuboriladi → javob ovozda → yana tinglaydi (to'xtatilguncha). Hook'lar erta `return` dan OLDIN.
  const [tts, setTts] = useState<boolean>(() => { try { return localStorage.getItem("ai.tts") === "1" } catch { return false } })
  const [dialog, setDialog] = useState(false)
  const [listening, setListening] = useState(false)
  const [speaking, setSpeaking] = useState(false)
  const dialogRef = useRef(false)
  const recogRef = useRef<any>(null)
  const ttsRef = useRef(tts); ttsRef.current = tts
  useEffect(() => {
    if (open) return
    // oyna yopildi — dialog va ovoz to'xtaydi
    dialogRef.current = false; setDialog(false); setListening(false); setSpeaking(false)
    try { recogRef.current?.abort?.() } catch {}
    recogRef.current = null
    try { (window as any).speechSynthesis?.cancel() } catch {}
  }, [open])
  useEffect(() => () => { try { (window as any).speechSynthesis?.cancel() } catch {}; try { recogRef.current?.abort?.() } catch {} }, [])
  if (!user || (!isTenantUser && (isCounterparty || isFactoryUser(user) || isShopUser(user))) || aiDisabled || tenantAiOff)
    return null

  function safeParse(s: string) {
    try {
      return JSON.parse(s)
    } catch {
      return undefined
    }
  }

  function scrollDown() {
    setTimeout(() => {
      listRef.current?.scrollTo({ top: listRef.current.scrollHeight, behavior: "smooth" })
    }, 80)
  }

  // B2/B4: AI tayyorlagan amalni tasdiqlash yoki bekor qilish.
  // Bajarish SERVERDA, mavjud servis metodlari orqali ketadi.
  const decidePending = async (msgIndex: number, p: AiPending, confirm: boolean, edited?: Record<string, any>[], force?: boolean) => {
    if (pendingBusy) return
    setPendingBusy(p.id)
    try {
      const res = await request({
        url: confirm ? "AIAgent/ConfirmAction" : "AIAgent/RejectAction",
        method: "post",
        // tog'a #2506: kartada tahrirlangan jadval qatorlari (server qayta tekshiradi, xato bo'lsa taklif kutishda qoladi)
        // tog'a #2688: force — takror ogohlantirishidan keyin «Baribir kiritish»
        data: { id: p.id, ...(confirm && edited ? { edited } : {}), ...(confirm && force ? { force: true } : {}) },
      })
      setMessages((prev) =>
        prev.map((m, i) =>
          i === msgIndex
            ? { ...m, pendingResult: confirm ? "done" : "rejected", pending: { ...p },
                pendingNote: confirm ? res?.data?.message : undefined, pendingLink: confirm ? res?.data?.link : undefined,
                pendingIds: confirm && Array.isArray(res?.data?.ids) ? res.data.ids : undefined }
            : m
        )
      )
      if (confirm) {
        // #2696: toast ham interfeys tilida (server matni o'zbekcha)
        antMessage.success(AI_DEST[p.tool] && Array.isArray(res?.data?.ids) && res.data.ids.length
          ? i18n.t("aiWrittenLine", { section: destName(p.tool), n: res.data.ids.length, ids: idList(res.data.ids), defaultValue: "✅ Записано в раздел «{{section}}»: {{n}} шт. ({{ids}})" })
          : i18n.t("aiDone"))
        // B (jonli holat): AI amali bazani o'zgartirdi — barcha ro'yxat/hisobot keshlari
        // eskirdi, keyingi ko'rinishda yangi ma'lumot tortiladi (jadval, qoldiq, kassa…)
        queryClient.invalidateQueries()
      }
      else antMessage.info(i18n.t("aiRejected"))
    } catch (e: any) {
      const err = e?.response?.data?.message || i18n.t("aiFailed")
      // tog'a #2506: tahrir xatosi (invalid_edit) — karta ochiq qoladi, foydalanuvchi tuzatib qayta bosadi
      if (e?.response?.data?.code === "invalid_edit") { antMessage.error(err); return }
      // tog'a #2688: xuddi shu yozuv yaqinda kiritilgan — taklif kutishda qoladi, karta «Baribir kiritish / Kiritmaslik» so'raydi
      if (e?.response?.status === 409 && e?.response?.data?.code === "duplicate") {
        const dupIds: number[] | undefined = Array.isArray(e?.response?.data?.ids) ? e.response.data.ids : undefined
        setMessages((prev) => prev.map((m, i) => (i === msgIndex ? { ...m, pendingResult: "dup", pendingNote: err, pendingLink: e?.response?.data?.link, pendingIds: dupIds } : m)))
        antMessage.warning(AI_DEST[p.tool] && dupIds?.length
          ? i18n.t("aiDupLine", { section: destName(p.tool), ids: idList(dupIds), defaultValue: "Такая же запись недавно уже внесена ({{ids}}) — раздел «{{section}}». Если внести ещё раз, она запишется дважды." })
          : err)
        return
      }
      setMessages((prev) => prev.map((m, i) => (i === msgIndex ? { ...m, pendingResult: err } : m)))
      antMessage.error(err)
    } finally {
      setPendingBusy(null)
    }
  }

  const send = async (text?: string, sec?: { key: string | null; auto: boolean }) => {
    const content = (text ?? input).trim()
    if (!content || loading) return
    // tog'a #2688: ochiq karta turganda «tasdiqla / ha / ok» deb YOZILSA — o'sha karta tasdiqlanadi (AI ga yuborilmaydi,
    // yangi taklif tuzilmaydi; avval AI xuddi shu xarajatga ikkinchi karta tuzardi va xarajat ikki marta yozilardi)
    if (isConfirmWord(content)) {
      let idx = -1
      for (let k = messages.length - 1; k >= 0; k--) {
        const m = messages[k]
        if (m.pending && (!m.pendingResult || m.pendingResult === "invalid")) { idx = k; break }
      }
      if (idx >= 0) {
        setMessages([...messages, { role: "user", content }])
        setInput("")
        setAutoConfirm({ id: messages[idx].pending!.id, n: Date.now() })
        scrollDown()
        return
      }
    }
    const next: AiMsg[] = [...messages, { role: "user", content }]
    setMessages(next)
    setInput("")
    setLoading(true)
    scrollDown()
    try {
      const res = await request({
        url: "AIAgent/Chat",
        method: "post",
        data: { messages: next.slice(-20).map((m) => ({ role: m.role, content: m.content })), ...bolimDan(sec) },   // tog'a #3902: bo'lim
      })
      bolimJavobdan(res?.data)
      const javob: string = res?.data?.needSection ? i18n.t("aiNeedSection", "Qaysi bo'limda bajaray? Bo'limni tanlang:") : (res?.data?.answer || i18n.t("aiNoAnswer"))
      setMessages([
        ...next,
        {
          role: "assistant",
          content: javob,
          tools: res?.data?.toolsUsed,
          table: res?.data?.table,
          pending: res?.data?.pendingAction ?? null,
          sectionOptions: res?.data?.needSection && Array.isArray(res?.data?.sectionOptions) ? res.data.sectionOptions : undefined,   // tog'a #3904
        },
      ])
      // Tog'a (2026-10-30): «Голосовой ответ» yoqiq yoki dialog rejimi — javob ovozda; dialogda o'qib bo'lgach yana tinglaydi
      if (ttsRef.current || dialogRef.current) gapir(javob, () => { if (dialogRef.current) tingla() })
    } catch (e: any) {
      setMessages([
        ...next,
        { role: "assistant", content: e?.response?.data?.message || i18n.t("aiServiceError") },
      ])
      if (dialogRef.current) dialogToxta()   // server xatosida dialog aylanib qolmasin
    } finally {
      setLoading(false)
      scrollDown()
    }
  }

  // tog'a #2506 (2026-09-24): ovoz → MATN → kiritish maydoni. Foydalanuvchi aytilganini ko'radi, tuzatadi va o'zi yuboradi.
  // Yozuv 16 kHz mono ga tushiriladi — 2 daqiqagacha (server chegarasi ham shunga mos).
  const transcribeVoice = async (raw: Blob) => {
    if (loading || transcribing) return
    setTranscribing(true)
    try {
      const wav = await toSpeechWav(raw)
      if (wav.size > 5_800_000) { antMessage.warning(i18n.t("aiVoiceTooLong")); return }
      const base64 = await blobToBase64(wav)
      if (!base64) return
      const res = await request({ url: "AIAgent/Transcribe", method: "post", data: { audioBase64: base64, audioFormat: "wav" } })
      const text = String(res?.data?.text || "").trim()
      if (!text) { antMessage.warning(i18n.t("aiVoiceError")); if (dialogRef.current) setTimeout(tingla, 300); return }
      // Tog'a (2026-10-30): dialog rejimida (brauzerda nutqni tanish bo'lmasa — zaxira yo'l) matn darhol yuboriladi
      if (dialogRef.current) { setTranscribing(false); send(text); return }
      setInput((prev) => (prev.trim() ? prev.trim() + " " + text : text))
      antMessage.info(i18n.t("aiVoiceReview", "Aytilgan gap matnga aylandi — tekshirib, «Yuborish» ni bosing"))
    } catch (e: any) {
      antMessage.error(e?.response?.data?.message || i18n.t("aiVoiceError"))
    } finally {
      setTranscribing(false)
    }
  }

  const sendVoice = async (blob: Blob) => {
    if (loading) return
    if (blob.size > 2_500_000) {
      antMessage.warning(i18n.t("aiVoiceTooLong"))
      return
    }
    const base64 = await new Promise<string>((resolve, reject) => {
      const fr = new FileReader()
      fr.onload = () => resolve(String(fr.result).split(",")[1] || "")
      fr.onerror = reject
      fr.readAsDataURL(blob)
    })
    if (!base64) return
    const next: AiMsg[] = [...messages, { role: "user", content: "🎤 " + i18n.t("aiVoiceMsg") }]
    setMessages(next)
    setLoading(true)
    scrollDown()
    try {
      const res = await request({
        url: "AIAgent/Chat",
        method: "post",
        data: {
          messages: [
            ...messages.slice(-19).map((m) => ({ role: m.role, content: m.content })),
            { role: "user", content: "", audioBase64: base64, audioFormat: "wav" },
          ],
          ...bolimDan(),   // tog'a #3902: ovozda ham bo'lim
        },
      })
      bolimJavobdan(res?.data)
      const transcript = res?.data?.transcript || ("🎤 (" + i18n.t("aiVoiceMsg") + ")")
      setMessages([
        ...messages,
        { role: "user", content: `🎤 ${transcript}` },
        // tog'a #2506 (2026-09-24): ovozli buyruqda tasdiqlash kartasi chiqmasdi — server `pendingAction` ni qaytaradi, lekin
        // bu yerda (matnli `send` dan farqli) u yozilmasdi va «Tasdiqlash» tugmasi umuman ko'rinmasdi
        { role: "assistant", content: res?.data?.needSection ? i18n.t("aiNeedSection", "Qaysi bo'limda bajaray? Bo'limni tanlang:") : (res?.data?.answer || i18n.t("aiNoAnswer")), tools: res?.data?.toolsUsed, table: res?.data?.table, pending: res?.data?.pendingAction ?? null,
          sectionOptions: res?.data?.needSection && Array.isArray(res?.data?.sectionOptions) ? res.data.sectionOptions : undefined },
      ])
    } catch (e: any) {
      setMessages([
        ...messages,
        { role: "user", content: ("🎤 (" + i18n.t("aiVoiceMsg") + ")") },
        { role: "assistant", content: e?.response?.data?.message || i18n.t("aiVoiceError") },
      ])
    } finally {
      setLoading(false)
      scrollDown()
    }
  }

  aiVoiceDone.current = (b: Blob) => transcribeVoice(b)   // #2506: avval matn (sendVoice — eski to'g'ridan-to'g'ri yo'l, zaxira)

  // ---- Tog'a (2026-10-30, skrinshot #464): «Голосовой ответ» va «Диалог» ----
  const nutqTili = () => { const l = String(i18n.language || "ru").slice(0, 2); return l === "uz" ? "uz-UZ" : l === "en" ? "en-US" : "ru-RU" }
  function ovozToxta() { try { (window as any).speechSynthesis?.cancel() } catch {} setSpeaking(false) }
  function stopListen() {
    try { recogRef.current?.abort?.() } catch {}
    recogRef.current = null
    setListening(false)
    if (voice.state === "recording") voice.cancel()
  }
  /** Javobni ovozda o'qish (brauzer nutq sintezi). Markdown belgilari olib tashlanadi, 1200 belgigacha. */
  function gapir(matn: string, keyin?: () => void) {
    const synth = (window as any).speechSynthesis
    const U = (window as any).SpeechSynthesisUtterance
    const toza = String(matn || "").replace(/\*\*/g, "").replace(/^#{1,4}\s*/gm, "").replace(/^\s*[-*•]\s*/gm, "").replace(/[`_>|]/g, "").replace(/\s+/g, " ").trim().slice(0, 1200)
    if (!synth || !U || !toza) { keyin?.(); return }
    try { synth.cancel() } catch {}
    const u = new U(toza)
    const lang = nutqTili()
    u.lang = lang
    try {
      const voices: SpeechSynthesisVoice[] = synth.getVoices?.() || []
      const v = voices.find((x) => String(x.lang || "").toLowerCase().startsWith(lang.slice(0, 2))) || voices.find((x) => String(x.lang || "").toLowerCase().startsWith("ru"))
      if (v) u.voice = v
    } catch {}
    u.rate = 1
    let tugadi = false
    const tamom = () => { if (tugadi) return; tugadi = true; setSpeaking(false); keyin?.() }
    u.onstart = () => setSpeaking(true)
    u.onend = tamom
    u.onerror = tamom
    synth.speak(u)
  }
  /** Dialog: brauzerda nutqni tanish bo'lsa (Chrome/Edge/Safari) — gap tugashi bilan yuboriladi; bo'lmasa — mikrofon yozuvi (To'xtatish → matn → yuborish). */
  function tingla() {
    if (!dialogRef.current) return
    const SR = (window as any).SpeechRecognition || (window as any).webkitSpeechRecognition
    if (SR) {
      try {
        const r = new SR()
        r.lang = nutqTili(); r.interimResults = false; r.maxAlternatives = 1; r.continuous = false
        r.onstart = () => setListening(true)
        r.onresult = (e: any) => {
          const t = String(e?.results?.[0]?.[0]?.transcript || "").trim()
          setListening(false)
          if (t) send(t); else if (dialogRef.current) setTimeout(tingla, 300)
        }
        r.onerror = (e: any) => {
          setListening(false)
          if (e?.error === "not-allowed" || e?.error === "service-not-allowed") { antMessage.warning(i18n.t("micDenied")); dialogToxta(); return }
          if (e?.error === "no-speech" || e?.error === "aborted" || e?.error === "network") { if (dialogRef.current && recogRef.current === r) setTimeout(tingla, 500) }
        }
        r.onend = () => { setListening(false); if (recogRef.current === r) recogRef.current = null }
        recogRef.current = r
        r.start()
        return
      } catch { /* pastdagi zaxira yo'l */ }
    }
    voice.start()   // zaxira: yozuv → AIAgent/Transcribe → transcribeVoice dialog rejimida matnni o'zi yuboradi
  }
  function dialogBoshla() {
    if (!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia)) { antMessage.warning(i18n.t("micUnsupported")); return }
    dialogRef.current = true
    setDialog(true)
    ovozToxta()
    tingla()
  }
  function dialogToxta() {
    dialogRef.current = false
    setDialog(false)
    stopListen()
    ovozToxta()
  }

  const isRecording = recOn

  return (
    <>
      {/* Tooltip yo'q: mobil qurilmada hover tugamay, tooltip qotib qolardi */}
      <button className="ai-fab" onClick={() => setOpen(true)} aria-label="SAV AI">
        <span className="ai-fab-icon">✦</span>
      </button>
      <Drawer
        className={"ai-drawer" + (full ? " ai-drawer-full" : "")}
        placement="right"
        width={full ? window.innerWidth : Math.min(440, window.innerWidth)}
        visible={open}
        onClose={() => setOpen(false)}
        closable={false}
        bodyStyle={{ display: "flex", flexDirection: "column", padding: 0 }}
      >
        {/* Yuqori panel */}
        <div className="ai-header">
          <div className="ai-header-left">
            <div className="ai-avatar">✦</div>
            <div>
              <div className="ai-name">SAV AI</div>
              <div className="ai-status">
                <span className="ai-dot" /> {i18n.t("aiOnlineReady")}
              </div>
            </div>
          </div>
          <div className="ai-header-actions">
            {/* Tog'a (2026-10-30): «Голосовой ответ» — javoblar ovozda o'qiladi (tanlov eslab qolinadi) */}
            <label className={"ai-tts" + (speaking ? " speaking" : "")} title={i18n.t("aiTtsHint", "Читать ответы вслух")} data-testid="ai-tts">
              <Switch size="small" checked={tts} onChange={(v) => { setTts(v); try { localStorage.setItem("ai.tts", v ? "1" : "0") } catch {} if (!v) ovozToxta() }} />
              <SoundOutlined />
              <span className="ai-tts-lbl">{i18n.t("aiTts", "Голосовой ответ")}</span>
            </label>
            {isSuperAdmin && (
              <Button type="text" className="ai-hbtn" icon={<SettingOutlined />} onClick={() => setManageOpen(true)} />
            )}
            {messages.length > 0 && (
              <Popconfirm title={i18n.t("aiClearConfirm")} okText={i18n.t("yes")} cancelText={i18n.t("no")} onConfirm={() => clearHistory()}>
                <Button type="text" className="ai-hbtn" icon={<ClearOutlined />} />
              </Popconfirm>
            )}
            {/* Tooltip emas — mobil qurilmada qotib qoladi; oddiy title */}
            <Button type="text" className="ai-hbtn" icon={full ? <FullscreenExitOutlined /> : <FullscreenOutlined />} onClick={toggleFull} data-testid="ai-full" title={full ? i18n.t("aiFullExit", "Обычный размер") : i18n.t("aiFull", "На весь экран")} aria-label="fullscreen" />
            <Button type="text" className="ai-hbtn" onClick={() => setOpen(false)}>✕</Button>
          </div>
        </div>

        {isTenantUser && <AiLimitStrip n={messages.length} />}

        {/* tog'a #3902/#3907: bo'lim tanlovi — faqat rolga (va menejer kartasiga) ochiq bo'limlar; tanlansa AI faqat shu bo'limda ishlaydi */}
        {bolimlar.length > 0 && (
          <div className="ai-sections" data-testid="ai-sections">
            <button className={"ai-sec" + (!bolim.key ? " on" : "")} onClick={() => tanlaBolim(null)} data-testid="ai-sec-all">
              🌐 {i18n.t("aiSecAll", "Umumiy")}
            </button>
            {bolimlar.map((b) => (
              <button key={b.key} className={"ai-sec" + (bolim.key === b.key ? " on" : "") + (bolim.key === b.key && bolim.auto ? " auto" : "")}
                onClick={() => tanlaBolim(b.key)} data-testid={"ai-sec-" + b.key}
                title={bolim.key === b.key && bolim.auto ? i18n.t("aiSecAutoTip", "AI so'rovdan aniqladi — boshqa bo'limni tanlash mumkin") : undefined}>
                {bolim.key === b.key && bolim.auto ? "✨ " : ""}{nomi(b)}
              </button>
            ))}
          </div>
        )}

        {/* Xabarlar */}
        <div className="ai-chat-list" ref={listRef}>
          {messages.length === 0 && (
            <div className="ai-chat-empty">
              <div className="ai-empty-logo">✦</div>
              <p>{i18n.t("aiGreeting")}</p>
              {SUGGESTIONS.map((s) => (
                <button key={s} className="ai-chat-suggestion" onClick={() => send(s)}>
                  {s}
                </button>
              ))}
            </div>
          )}
          {messages.map((m, i) => (
            <div key={i} className={`ai-chat-msg ${m.role === "user" ? "own" : "bot"}`}>
              {m.role === "assistant" && <div className="ai-msg-avatar">✦</div>}
              <div className="ai-chat-bubble">
                {renderRich(m.content)}
                {/* 8.1: tool natijasi jadval + (raqamli ustun bo'lsa) mini-grafik */}
                {m.table && m.table.rows?.length > 0 && <AiResultTable table={m.table} />}
                {/* B2: AI yozuvchi amal tayyorlagan — foydalanuvchi tasdiqlamaguncha bajarilmaydi */}
                {m.pending && (
                  <PendingActionCard
                    pending={m.pending}
                    result={m.pendingResult}
                    busy={pendingBusy === m.pending.id}
                    onDecide={(ok, edited, force) => decidePending(i, m.pending!, ok, edited, force)}
                    note={m.pendingNote}
                    link={m.pendingLink}
                    onOpen={(to) => { setOpen(false); history.push(to) }}
                    autoConfirm={autoConfirm && autoConfirm.id === m.pending.id ? autoConfirm.n : 0}
                    ids={m.pendingIds}
                  />
                )}
                {/* tog'a #3904: yozuv amali — bo'lim aniq emas: tanlansa oxirgi so'rov shu bo'limda qayta yuboriladi */}
                {m.sectionOptions && m.sectionOptions.length > 0 && (
                  <div className="ai-sec-pick" data-testid="ai-sec-pick">
                    {m.sectionOptions.map((o) => (
                      <Button key={o.key} size="small" onClick={() => {
                        tanlaBolim(o.key)
                        const oldingi = [...messages.slice(0, i)].reverse().find((x) => x.role === "user" && !x.content.startsWith("🎤 ("))
                        if (oldingi) send(oldingi.content.replace(/^🎤 /, ""), { key: o.key, auto: false })
                      }} data-testid={"ai-sec-pick-" + o.key}>{nomi(o)}</Button>
                    ))}
                  </div>
                )}
                {m.tools && m.tools.length > 0 && (
                  <div className="ai-chat-tools">
                    {m.tools.map((t, j) => (
                      <span key={j} className="ai-tool-chip" title={t.tool}>🔎 {toolLabel(t.tool)}</span>
                    ))}
                  </div>
                )}
              </div>
            </div>
          ))}
          {loading && (
            <div className="ai-chat-msg bot">
              <div className="ai-msg-avatar">✦</div>
              <div className="ai-chat-bubble ai-typing">
                <span /><span /><span />
              </div>
            </div>
          )}
        </div>

        {/* Kiritish paneli */}
        <div className="ai-chat-input">
          <Input.TextArea
            value={input}
            onChange={(e) => setInput(e.target.value)}
            onPressEnter={(e) => {
              if (!e.shiftKey) {
                e.preventDefault()
                send()
              }
            }}
            placeholder={dialog && listening ? "🎙 " + i18n.t("aiListening", "Слушаю…") : dialog && speaking ? "🔊 " + i18n.t("aiSpeaking", "Говорю…") : isRecording ? `🔴 ${i18n.t("aiRecording")} ${Math.floor(recSec / 60)}:${String(recSec % 60).padStart(2, "0")} / 2:00` : transcribing ? "⏳ " + i18n.t("aiTranscribing", "Ovoz matnga aylantirilmoqda…") : i18n.t("aiAskPlaceholder")}
            autoSize={{ minRows: 1, maxRows: 6 }}
            disabled={loading || isRecording || transcribing}
            data-testid="ai-input"
            bordered={false}
          />
          {/* tog'a #3355/#3408: qog'ozdagi ro'yxat rasmi → jadval → bo'lim formasi */}
          <AiPhotoButton section={bolim.key} disabled={loading || isRecording || transcribing} onDone={() => setOpen(false)} />
          {/* Tog'a (2026-10-30): «Диалог» — uzluksiz ovozli suhbat (gapirasiz → javob ovozda → yana tinglaydi) */}
          <Button
            shape="round"
            className={"ai-dialog-btn" + (dialog ? " on" : "")}
            type={dialog ? "primary" : "default"}
            danger={dialog}
            icon={dialog ? <StopOutlined /> : <AudioOutlined />}
            onClick={() => (dialog ? dialogToxta() : dialogBoshla())}
            disabled={!dialog && (loading || transcribing || isRecording)}
            title={i18n.t("aiDialogHint", "Голосовой диалог: говорите — помощник ответит голосом и снова будет слушать")}
            data-testid="ai-dialog"
          >
            {dialog ? (listening ? i18n.t("aiListening", "Слушаю…") : speaking ? i18n.t("aiSpeaking", "Говорю…") : i18n.t("aiDialogStop", "Стоп")) : i18n.t("aiDialog", "Диалог")}
          </Button>
          <Button
            shape="circle"
            danger={isRecording}
            type={isRecording ? "primary" : "text"}
            icon={isRecording ? <StopOutlined /> : <AudioOutlined />}
            onClick={() => (isRecording ? voice.stop() : voice.start())}
            disabled={loading || transcribing}
            loading={transcribing}
            aria-label={i18n.t("aiVoiceQuestion")}
          />
          <Button
            shape="circle"
            type="primary"
            className="ai-send-btn"
            icon={<SendOutlined />}
            onClick={() => send()}
            disabled={loading || isRecording || !input.trim()}
          />
        </div>
      </Drawer>

      {/* Admin: per-user AI boshqaruvi */}
      <Drawer
        title={"🛡 " + i18n.t("aiAdminTitle")}
        placement="right"
        width={Math.min(isMainTenantAdmin ? 1000 : 680, window.innerWidth)}
        visible={manageOpen}
        onClose={() => setManageOpen(false)}
      >
        {/* AI billing: token zaxirasi (egasi tanlovi — ichki kredit+kvota) */}
        {billing && (
          <div style={{ background: "#f6f8fc", border: "1px solid #e5e9f2", borderRadius: 10, padding: 12, marginBottom: 14 }}>
            <div style={{ fontWeight: 700, marginBottom: 6 }}>💳 {i18n.t("aiTokenReserve")}</div>
            {billing.unlimited ? (
              <div style={{ color: "#16a34a", fontSize: 13 }}>
                Bu tizim (glavniy) — <b>cheksiz</b>. Oxirgi 30 kun: {Number(billing.last30dTokens || 0).toLocaleString("ru-RU")} token ({billing.last30dCalls} ta so'rov).
              </div>
            ) : (
              <>
                <div style={{ fontSize: 13 }}>
                  Qolgan: <b>{nonNeg(billing.remainingTokens).toLocaleString("ru-RU")}</b> / {Number(billing.creditTokens || 0).toLocaleString("ru-RU")} token
                </div>
                <div style={{ color: "#64748b", fontSize: 12 }}>
                  Ishlatilgan: {Number(billing.usedTokens || 0).toLocaleString("ru-RU")} · 30 kun: {Number(billing.last30dTokens || 0).toLocaleString("ru-RU")}
                </div>
                <AiForecastLine f={billing.forecast} />
                <div style={{ display: "flex", gap: 6, marginTop: 8 }}>
                  {[100000, 1000000, 5000000].map((n) => (
                    <Button key={n} size="small"
                      onClick={() => addCredit({ tenantId: billing.tenantId, addTokens: n })}>
                      +{n >= 1000000 ? n / 1000000 + "M" : n / 1000 + "k"}
                    </Button>
                  ))}
                </div>
              </>
            )}
            {billing.topUsers?.length > 0 && (
              <div style={{ marginTop: 8, fontSize: 12, color: "#64748b" }}>
                Top: {billing.topUsers.slice(0, 3).map((u: any) => `${u.name} (${Number(u.tokens).toLocaleString("ru-RU")})`).join(" · ")}
              </div>
            )}
          </div>
        )}

        {/* tog'a #3835: xodimlar — barcha tizimlar (bosh admin), tepada filtr, filtrdagi hammaga limit / AI yoqish-o'chirish */}
        <AiUsersAdmin allTenants={isMainTenantAdmin} />
      </Drawer>
    </>
  )
}

/** Boshliq (2026-09-07): hamkor o'z chatida limit holatini ko'radi — kredit qoldig'i, oyna/hafta/oy sarfi; tugagan bo'lsa qizil */
function AiLimitStrip({ n }: { n: number }) {
  const { data: st } = useQuery(["AI_LIMIT_STATUS", n], async () => (await request({ url: "AIAgent/LimitStatus" })).data, { refetchInterval: 60000, staleTime: 5000 })
  if (!st || st.unlimited || !st.configured) return null
  const f = (v: any) => Number(v || 0).toLocaleString("ru-RU")
  const part = (label: string, used: any, limit: any) => (Number(limit) > 0 ? <span className={"ai-limit-part" + (Number(used) >= Number(limit) ? " over" : "")}>{label}: <b>{f(used)}</b> / {f(limit)}</span> : null)
  return (
    <div className={"ai-limit-strip" + (st.allowed ? "" : " blocked")} title={st.message || ""}>
      {Number(st.creditTokens) > 0 && <span className="ai-limit-part">{i18n.t("aiCreditLbl")}: <b>{f(nonNeg(st.remaining))}</b> / {f(st.creditTokens)}</span>}   {/* #3435: kredit qo'yilmagan — ko'rsatilmaydi */}
      {st.mode === 1 && part(st.windowHours + " " + i18n.t("aiHoursShort"), st.usedWindow, st.windowLimit)}
      {st.mode === 1 && part(i18n.t("aiWeekly"), st.usedWeek, st.weeklyLimit)}
      {part(i18n.t("aiMonthly"), st.usedMonth, st.monthlyLimit)}
      {!st.allowed && <span className="ai-limit-msg">⛔ {st.message}</span>}
    </div>
  )
}
